import React from 'react';
import { OptionProp, OptionsGroup } from '../custom-select/custom-select-input';

type SuggestionListProps = {
    isOpen?: boolean;
    options?: OptionsGroup;
    onClick: (suggestion: OptionProp) => void;
};

const renderOption = (option: OptionProp, onClick: SuggestionListProps['onClick'], key: string) => {
    return (
        <li className="typeaheadfield-suggestionlist-option" key={key}>
            <a
                className="typeaheadfield-suggestionlist-option-key"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onClick(option);
                }}
                tabIndex={0}
            >
                {option.label}
            </a>
        </li>
    );
};

const renderGroupedOption = (options: OptionProp[], onClick: SuggestionListProps['onClick'], groupkey: string) => {
    const groupedOptionOutput: JSX.Element[] = [];
    Array.prototype.forEach.call(options, (o: OptionProp, index: string) => {
        groupedOptionOutput.push(renderOption(o, onClick, `${groupkey}-${index}`));
    });
    return groupedOptionOutput;
};

const SuggestionsList = ({ isOpen, options, onClick }: SuggestionListProps) => {
    if (!isOpen) {
        return null;
    }

    const output: JSX.Element[] = [];

    if (options && options.size) {
        options.forEach((option, key) => {
            // check if key is index liked
            if (!isNaN(parseInt(`${key}`))) {
                output.push(renderOption(option as OptionProp, onClick, key));
            } else if (Array.isArray(option)) {
                // else check if it is an array of options
                const groupedOptionOutput = renderGroupedOption(option, onClick, key);
                groupedOptionOutput.length &&
                    output.push(
                        <li tabIndex={0} key={key}>
                            <p className="typeaheadfield-suggestionlist-options-group-header">{key}</p>
                            <ul className="typeaheadfield-suggestionlist-options-group">{groupedOptionOutput}</ul>
                        </li>
                    );
            }
        });
    } else {
        output.push(
            <li key={0} tabIndex={0}>
                Ingen match
            </li>
        );
    }

    return (
        <div className="typeaheadfield-suggestionlist" role="dialog" tabIndex={-1}>
            <ul className="typeaheadfield-suggestionlist-options">{output}</ul>
        </div>
    );
};

export type { SuggestionListProps };
export { SuggestionsList };
export default SuggestionsList;
